// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "collectives-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-Ly0obkwS_mjs":"b91ae1b0e1c55e18f840","vendors-node_modules_rehype-highlight_index_js":"846049f9c2393c4718e7","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-CSmrMOEO_mjs":"e23a9b9745e93a814939"}[chunkId] + "";
};